module.exports = __webpack_public_path__ + "img/orders60.8efcff7a.png";